import React, { Component } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import avatar1 from "../../assets/images/users/avatar-1.jpg"
import profileImg from "../../assets/images/index.jpg"
import PropTypes from "prop-types"

class WelcomeComp extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { userdetail } = this.props;
    return (
      <React.Fragment>
        <Card className="overflow-hidden">
          <div className="bg-primary bg-soft" style={{paddingBottom:64}}>
            <Row>
              <Col xs="12">
                <div className="text-primary p-3">
                  <h5 className="text-primary">Welcome {userdetail?.firstName +" "+ userdetail?.lastName}</h5>
                  <p>{userdetail?.organizationName}</p>
                </div>
              </Col>
              <Col xs="5" className="align-self-end">
                {/* <img src={profileImg} alt="" className="img-fluid" /> */}
              </Col>
            </Row>
          </div>
          
        </Card>
      </React.Fragment>
    )
  }
}

WelcomeComp.propTypes = {
  userdetail: PropTypes.object
}

export default WelcomeComp
